import React from 'react';
import { CtaButton } from './CtaButton';
import { painPoints } from '../data/content';
export function PainPoints() {
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-201" data-mp="2lm0wbgl8jiwo">
      <div className="mx-auto max-w-4xl" data-id="element-202" data-mp="26z7o0va4vddz">
        <h2 className="text-center font-display text-[26px] font-extrabold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-203" data-mp="26y619tjr92gf">
          Ti riconosci in una di queste situazioni?
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-[15px] font-medium text-inksoft sm:text-lg" data-id="element-204" data-mp="1xw6k918qpydh">
          Se hai risposto “sì” anche solo a una di queste, questo Kit è stato creato per te.
        </p>

        <ul className="mt-9 grid gap-3 sm:grid-cols-2 sm:gap-4" data-id="element-205" data-mp="1o1obvisdpenc">
          {painPoints.map(point => <li key={point.text} className="flex gap-3 rounded-2xl border border-brand-100 bg-white p-4 sm:p-5" data-id="element-206" data-mp="1t0r94h24agkr">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-207" data-mp="3nbmruc70nc19">
                {point.emoji}
              </span>
              <p className="text-[14px] font-medium leading-snug text-ink/85 sm:text-[15px]" data-id="element-208" data-mp="1yyu5r7f9jr9k">
                {point.text}
              </p>
            </li>)}
        </ul>

        <div className="mt-10 rounded-3xl bg-brand-900 p-6 text-center sm:p-9" data-id="element-209" data-mp="27rp2tdukugo9">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-gold" data-id="element-210" data-mp="23r56gchtvh36">
            La buona notizia?
          </p>
          <p className="mt-4 font-display text-[22px] font-bold leading-snug text-white sm:text-3xl" data-id="element-211" data-mp="1g22qd92udwas">
            Non devi memorizzare centinaia di pagine di linee guida.
          </p>
          <p className="mx-auto mt-4 max-w-xl text-[15px] font-medium leading-relaxed text-white/80 sm:text-lg" data-id="element-212" data-mp="1p3ab0ocfqyme">
            Ti serve un Percorso Clinico organizzato che ti aiuti a orientarti nelle decisioni più
            importanti della visita.
          </p>
        </div>

        <div className="mt-10" data-id="element-213" data-mp="2vjckd55y8fdv">
          <CtaButton label="Voglio decidere con maggiore sicurezza" note="Download immediato · Garanzia di 7 giorni" data-id="element-214" data-mp="2vi1lnjrd1xtm" />
        </div>
      </div>
    </section>;
}